module.exports = __webpack_public_path__ + "static/media/1.a9735ef3.jpg";